import { useEffect, useState } from 'react'

import { Box, Container } from '@mui/material'

import { Route, Routes } from 'react-router-dom'
import PrivateRoute from 'component/PrivateRoute'

import Top from 'component/Top'
import Header from 'component/Header'
import Ranking from 'component/Ranking'
import PrivacyPolicy from 'component/Legal/PrivacyPolicy'
import { useMediaContext } from 'context/MediaContext'
import { useAuthContext } from 'context/AuthContext'
import { User } from 'model/User'
import * as userRepository from 'repository/UserRepository'

import bgimg from '../asset/bgimg.png'
import MyPageRoot from './MyPage/MyPageRoot'
import Rule from 'component/Rule'
import { Matching } from 'component/Matching/Matching'
import Game from './Game/Game'
import Analytics from './Statistics/Analytics'
import AnalyticsDetail from './Statistics/AnalyticsDetail'
import { Subscription } from './Subscription'
import Commerce from './Legal/Commerce'

export default function Root() {
  /**
   * ユーザー情報を設定
   */
  const { auth } = useAuthContext()
  const [user, setUser] = useState<User | null>(null)
  useEffect(() => {
    if (auth) userRepository.findFromCache(auth.uid).then(it => setUser(it))
  }, [auth])
  
  const media = useMediaContext()

  return (
    <Box
      sx={{
        width: '100vw',
        height: '100vh !important',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Container maxWidth='lg'>
        {user && <Header user={user} />}
      </Container>

      <Container
        maxWidth='md'
        sx={{
          pt: media.isPc ? 3 : 1,
          pb: media.isPc ? 3 : 1,
          flex: 1,
          overflow: 'auto',
          backgroundImage: `url(${bgimg})`,
          backgroundSize: media.isPc ? 200 : 125
        }}
      >
        {user &&
          <Routes>
            <Route path='/' element={<PrivateRoute children={<Top user={user} />} />} />
            <Route path='/match' element={<PrivateRoute children={<Matching />} />} />
            <Route path='/game' element={<PrivateRoute children={<Game />} />} />
            <Route path='/ranking' element={<PrivateRoute children={<Ranking user={user} />} />} />
            <Route path='/privacypolicy' element={<PrivateRoute children={<PrivacyPolicy />} />} />
            <Route path='/commerce' element={<PrivateRoute children={<Commerce />} />} />
            <Route path='/mypage' element={<PrivateRoute children={<MyPageRoot />} />} />
            <Route path='/rule' element={<PrivateRoute children={<Rule />} />} />
            <Route path='/analytics' element={<PrivateRoute children={<Analytics />} />} />
            <Route path='/analyticsdetail' element={<PrivateRoute children={<AnalyticsDetail />} />} />
            <Route path='/subscription' element={<PrivateRoute children={<Subscription />} />} />
          </Routes>
        }
      </Container>
    </Box>
  )
}